// extracted by mini-css-extract-plugin
export default {"container":"cd_g","containerWithoutImage":"cd_jw","photoWrapper":"cd_jx","photo":"cd_jy","isGrey":"cd_jz","isWhite":"cd_jB"};